import type { QueryClient } from '@tanstack/react-query';
import {
	buildTutorialDemonstracaoEndedSession,
	buildTutorialDemonstracaoMedicalRecordSession,
	buildTutorialDemonstracaoMedicalRecordWithAiContent,
	buildTutorialDemonstracaoPatient,
	TUTORIAL_DEMO_MEDICAL_RECORD_ID,
	TUTORIAL_DEMO_MEDICAL_RECORD_SESSION_ID,
	TUTORIAL_DEMO_PATIENT_ID,
	TUTORIAL_DEMO_SESSION_ID,
} from './tutorialDemonstracaoMock';

const sessionsQueryKey = (patientId: string) =>
	[
		'sessions',
		true,
		undefined,
		undefined,
		undefined,
		undefined,
		patientId,
		undefined,
		50,
		1,
		undefined,
		undefined,
	] as const;

export function seedTutorialDemonstracaoPostEndQueryCache(
	queryClient: QueryClient,
	professional: Professionals.Professional,
): void {
	const patient = buildTutorialDemonstracaoPatient(professional.id);
	const endedSession = buildTutorialDemonstracaoEndedSession({
		professional,
		patient,
	});
	const medicalRecord = buildTutorialDemonstracaoMedicalRecordWithAiContent();
	const medicalRecordSession =
		buildTutorialDemonstracaoMedicalRecordSession();

	const medicalRecordSessionsList: MedicalRecords.GetMedicalRecordSessionsResponse =
		{
			data: [medicalRecordSession],
			pagination: {
				total: 1,
				page: 1,
				limit: 20,
				totalPages: 1,
			},
		};

	const platformSessions: Sessions.GetSessionsRespose = {
		data: [endedSession],
		total: 1,
	};

	const posProcessingStatus: Sessions.PosProcessingStatus = {
		is_done: true,
		pos_process_status: 'COMPLETED',
		pos_process_status_message: 'Demonstração concluída',
	};

	const entries: [readonly unknown[], unknown][] = [
		[['session', TUTORIAL_DEMO_SESSION_ID], endedSession],
		[
			['session-pos-processing', TUTORIAL_DEMO_SESSION_ID],
			posProcessingStatus,
		],
		[['patient', TUTORIAL_DEMO_PATIENT_ID], patient],
		[['medical-record', TUTORIAL_DEMO_PATIENT_ID], medicalRecord],
		[
			[
				'medical-record-session',
				TUTORIAL_DEMO_MEDICAL_RECORD_ID,
				TUTORIAL_DEMO_MEDICAL_RECORD_SESSION_ID,
				'post-process',
			],
			medicalRecordSession,
		],
		[
			['medical-record-sessions', TUTORIAL_DEMO_MEDICAL_RECORD_ID, 1, 20],
			medicalRecordSessionsList,
		],
		[sessionsQueryKey(TUTORIAL_DEMO_PATIENT_ID), platformSessions],
	];

	for (const [key, value] of entries) {
		queryClient.setQueryData(key, value);
	}
}

export { TUTORIAL_DEMO_SESSION_ID };
